const Env = {
    live: 'live',
    sandbox: 'sandbox',
};

export default Env;
